import { Redirect } from 'react-router-dom'
import React, { ReactElement } from 'react'

import { useQueryParams } from '../../hooks/useQueryParams'
import { businessStateKeys } from '../../utils/authAppState'
import { getLandingLocale } from '../../utils/landingLocale'

const Landing = (): ReactElement => {
  const query = useQueryParams()
  const userLocale = getLandingLocale(
    new URLSearchParams({
      languageCode: query.get('languageCode') || '',
      countryCode: query.get('countryCode') || '',
    }).toString(),
  )
  const search = new URLSearchParams()
  businessStateKeys.forEach((key) => {
    const value = query.get(key)
    if (value) search.set(key, value)
  })
  return (
    <Redirect
      to={`/${userLocale}/auth0${search.toString() ? `?${search}` : ''}`}
    />
  )
}

export default Landing
